import styled, { css } from "styled-components";
import { media, theme } from "../../theme/theme";
import { getV3ContentDimension } from "../../utils/getV3ContentDimension";
import { ProfileCollectionLayout, ProfileView, UserProfileStyle } from "@authory-packages/core";
import { PROFILE_HERO_PAD } from "../../components/ProfileHero";
import { V3Title } from "../../components/Typography";
import { AuthoryColorSchemeProps, UserThemableParagraph } from "../../components/ReusableStyledComponents/FontSetUtilities";

export const PCFWrapper = styled.div<{ $sideMargins: boolean, $isPrivateView: boolean }>`
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: column;

    ${media.tablet} {
        flex-direction: row;
        align-items: flex-start;
    }

    > div {
        ${media.tablet} {
            margin-bottom: 0;
        }

        &:first-child {
            width: 100%;

            ${media.tablet} {
                margin-right: ${({ $sideMargins }) => $sideMargins ? "20px;" : undefined}
            }
        }

        &:nth-child(2) {
            flex-shrink: 0;
            width: 100%;
            margin-top: 24px;
            display: ${({ $isPrivateView }) => $isPrivateView ? "none" : undefined};

            ${media.tablet} {
                margin-top: 0;
                display: block;
                width: auto;
                margin-left: ${({ $sideMargins }) => $sideMargins ? "20px;" : undefined}
            }
        }
    }
`;

export const PublicProfileSearchItemsPad = styled.div`
    padding: 0 18px;
`;

type ContentSizerArgs = {
    $viewType: ProfileView;
    $profileStyle: UserProfileStyle;
    $isAboutPage?: boolean;
    $profileCollectionLayout: ProfileCollectionLayout;
}

export const ShareContentSizerCSS = css<ContentSizerArgs>`
    margin: 0 auto;
    max-width: ${({ $viewType, $isAboutPage,  $profileCollectionLayout }) => `${getV3ContentDimension($viewType, !!$isAboutPage, $profileCollectionLayout ) + PROFILE_HERO_PAD}px`};
    width: 100%;
`;

export const PublicProfileSearchItemsContentSizer = styled.div<ContentSizerArgs>`
    position: relative;
    padding-top: 15px;
    ${ShareContentSizerCSS}

    
    ${media.custom(theme.v3.layout.sidebarLayout.mobile)} {
        padding: ${({$profileCollectionLayout }) => $profileCollectionLayout === ProfileCollectionLayout.tabs ? "18px 40px 0" :  "32px 40px 0"};
        margin-top: ${({ $isAboutPage, $profileStyle }) => $profileStyle === UserProfileStyle.sidebar ? 0 : $isAboutPage ? "-40px" : "-60px"};
        border-radius: 6px;
        background: ${({ theme }) => theme.customization.backgroundColor};
    }
`;

export const V3PublicPageTeaser = styled.div`
    padding: 8px 10px;
    box-shadow: 0px 8px 20px rgba(0, 0, 0, 0.2);
    text-align: center;
`;

export const V4EditCoverPos = styled.div<ContentSizerArgs>`
    position: absolute;
    left: 50%;
    padding: 0 18px;
    width: 100%;
    transform: translateX(-50%);
    bottom: ${({ $profileStyle }) => $profileStyle === UserProfileStyle.sidebar ? "20px" : "75px"};
    left: ${({ $profileStyle }) => $profileStyle === UserProfileStyle.sidebar ? "75px" : undefined};

    > div {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        ${ShareContentSizerCSS}

        > div {
            &:not(:last-child) {
                margin-right: 15px;
            }
        }
    }
`;

const sharedSidebartitleCSS = css`
    font-size: 30px;
    font-weight: ${({ theme }) => theme ? `${theme.typography.weight.regular}` : null};
    letter-spacing: -1.08px;
    line-height: 37px;

    ${media.custom(1350)} {
        font-size: 36px;
        line-height: 44px;
    }
`;

const UserThemableSidebarTitle = styled(V3Title)<AuthoryColorSchemeProps>`
    ${UserThemableParagraph}
`;

export const SidebarLayoutTitle = styled(UserThemableSidebarTitle)`
    ${sharedSidebartitleCSS}
`;

export const ProfileHeroEditConverWrapper = styled.div`
    position: relative;
`;